// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__4_PKr","title":"ClientReferral_title__Up5Hh","itemText":"ClientReferral_itemText__72-1P"};